import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  cardReaderFormState,
  SecurityAddState,
  SecurityEditState,
  ActionType,
  cardReaderDatas,
  recordNumberForEdit,
  cardReaderEditDatas,
} from "../atoms/atoms";
import { SecurityForm } from "../forms/SecurityForm";
import CardReaderForm from "../forms/CardReaderForm";
import { useForm } from "react-hook-form";

export const ViewContainer: React.FC<{}> = () => {
  const [isCardReaderOpen, setIsCardReaderOpen] = useState(false);
  const [isAdd, setIsAddState] = useRecoilState(SecurityAddState);
  const [isEdit, setIsEditState] = useRecoilState(SecurityEditState);
  const [cardReaderActionState] = useRecoilState(cardReaderFormState);
  const [dataCardReader] = useRecoilState(cardReaderDatas);
  const [selectedRecordNumber] = useRecoilState(recordNumberForEdit);
  // recoil from Office module
  const [editDataCardReader] = useRecoilState(cardReaderEditDatas);

  const FormMethods = useForm();
  const { setValue } = FormMethods;
  const cardReaderDetails = {
    ...((dataCardReader ?? {}) as any),
    ...((editDataCardReader ?? {}) as any),
    recordNumber:
      (editDataCardReader as any)?.recordNumber ??
      (dataCardReader as any)?.recordNumber ??
      selectedRecordNumber,
    siteAdmins: (editDataCardReader as any)?.siteAdmins ??
      (dataCardReader as any)?.siteAdmins ?? [
        {
          employeeId: 0,
          email: "",
          isFieldsDisabled: false,
          isMasterAdmin: false,
          name: "",
          phoneNumber: "",
        },
      ],
    masterAdmin: (editDataCardReader as any)?.masterAdmin ??
      (dataCardReader as any)?.masterAdmin ?? [
        {
          employeeId: 0,
          email: "",
          isFieldsDisabled: false,
          isMasterAdmin: true,
          name: "",
          phoneNumber: "",
        },
      ],
  };

  useEffect(() => {
    if (cardReaderActionState === ActionType.ADD) {
      setValue(`accountNumberBilling`, "");
      setValue(`accountNumberBrivo`, "");
      setValue(`additionalDescription`, "");
      setValue(`brivoSiteNumber`, "");
      setValue(`cancellationDate`, "");
      setValue(`cardCompanyName`, "");
      setValue(`cardAddress`, "");
      setValue(`cardEmailAddress`, "");
      setValue(`cardHours`, "");
      setValue(`cardName`, "");
      setValue(`cardType`, "");
      setValue(`confieSiteNumber`, "");
      setValue(`coverageEndDate`, "");
      setValue(`coverageStartDate`, "");
      setValue(`createdBy`, "");
      setValue(`createdDate`, "");
      setValue(`dataConnectionEquipment`, "");
      setValue(`dataConnectionPort`, "");
      setValue(`installDate`, "");
      setValue(`ipAddress`, "");
      setValue(`ipAddressSettingOption`, null);
      setValue(`isActive`, "");
      setValue(`isKeyCardAccess`, "");
      setValue(`isWarranty`, "");
      setValue(`warrantyCoverage`, "");
      setValue(`parkingCardFormat`, "");
      setValue(`parkingSiteNumber`, "");
      setValue(`vendorCS`, "");
      setValue(`vendorId`, "");
      setValue(`vendorPhone`, "");
      setValue("masterAdmin", [
        {
          employeeId: 0,
          email: "",
          isFieldsDisabled: false,
          isMasterAdmin: true,
          name: "",
          phoneNumber: "",
        },
      ]);

      setValue("siteAdmins", [
        {
          employeeId: 0,
          email: "",
          isFieldsDisabled: false,
          isMasterAdmin: false,
          name: "",
          phoneNumber: "",
        },
      ]);

      setValue("groupInfos", [
        {
          daysOftheWeek: "",
          daysOftheWeekArr: [],
          doors: [""],
          endTime: "",
          startTime: "",
          groupTitle: "",
          staffGroup: "",
          mondayStartTime: "",
          mondayEndTime: "",
          tuesdayStartTime: "",
          tuesdayEndTime: "",
          wednesdayStartTime: "",
          wednesdayEndTime: "",
          thursdayStartTime: "",
          thursdayEndTime: "",
          fridayStartTime: "",
          fridayEndTime: "",
          saturdayStartTime: "",
          saturdayEndTime: "",
          sundayStartTime: "",
          sundayEndTime: "",
        },
      ]);
    }
  }, [cardReaderActionState]);

  //END
  return (
    <>
      <div style={{ display: !isCardReaderOpen ? "none" : undefined }}>
        <CardReaderForm
          cardReaderDetails={cardReaderDetails}
          FormMethods={FormMethods}
          isAdd={isAdd}
          setIsCardReaderOpen={setIsCardReaderOpen}
        />
      </div>
      <div style={{ display: isCardReaderOpen ? "none" : undefined }}>
        <SecurityForm
          viewFromOffice={false}
          isAdd={isAdd}
          isEdit={isEdit}
          setIsAdd={setIsAddState}
          setIsEdit={setIsEditState}
          setIsCardReaderOpen={setIsCardReaderOpen}
        />
      </div>
    </>
  );
};
